import { setCookie } from './_cookie';

export function trigger() {
  const htmlEl = document.querySelector('html');
  const navTrigger = document.querySelector('.trigger-nav');
  const header = document.querySelector('.header');
  if (navTrigger) {
    navTrigger.addEventListener('click', (e) => {
      e.preventDefault();
      if (document.body.classList.contains('is-nav-active')) {
        document.body.classList.remove('is-nav-active', 'is-search-active');
        if(header) header.style.height = '';
      } else {
        document.body.classList.remove('is-search-active');
        document.body.classList.add('is-nav-active');
        if(header && header.dataset.navActiveHeight) header.style.height = `${header.dataset.navActiveHeight}px`;
      }
    })
  }
  const navSearch = document.querySelector('.trigger-search');
  if (navSearch) {
    navSearch.addEventListener('click', (e) => {
      e.preventDefault();
      if(header) header.style.height = '';
      if (document.body.classList.contains('is-search-active')) {
        document.body.classList.remove('is-search-active', 'is-nav-active');
      } else {
        document.body.classList.remove('is-nav-active');
        document.body.classList.add('is-search-active');
      }
    })
  }
  const handleReset = () => {
    document.body.classList.remove('is-search-active', 'is-nav-active');
    if(header) header.style.height = '';
  }
  const navReset = document.querySelector('.trigger-reset');
  if (navReset) {
    navReset.addEventListener('click', (e) => {
      e.preventDefault();
      handleReset();
    })
  }
  let lastInnerWidth = window.innerWidth;
  window.addEventListener('resize', () => {
    if (lastInnerWidth !== window.innerWidth) {
      lastInnerWidth = window.innerWidth;
      handleReset();
    }
  });

  const navColorMode = document.querySelectorAll('[data-colormode]');
  if (navColorMode.length) {
    navColorMode.forEach((color) => {
      color.addEventListener('click', (e) => {
        e.preventDefault();
        const mode = color.dataset.colormode;
        if(mode) {
          htmlEl.classList.remove('colormode-light', 'colormode-dark', 'colormode-peach', 'colormode-lemon');
          htmlEl.classList.add(`colormode-${mode}`);
          setCookie('smls-colorMode', mode);
        }
      });
    });
  }
}